import {
  customPlant,
  inverterInfo,
  objectPowerAndIrra,
  objectTimes,
  plantAnalyticsInfo,
  plantInfo,
  ResponseData,
  responseDataChart,
  responseDataReport,
  titleInfoTwo,
} from 'models';
import { alarmcustomize, alarmInfo } from 'models/alarm';
import moment from 'moment';

export const formatDataTable = (array: plantInfo[]): customPlant[] => {
  let newArray: customPlant[] = [];
  array.forEach((x) => {
    let newItem = {
      label: x.label,
      key: x.id,
    };
    return (newArray = [...newArray, newItem]);
  });
  return newArray;
};
export const formatDatatable = (array: alarmInfo[]): alarmcustomize[] => {
  let newArray: alarmcustomize[] = [];
  array.forEach((x) => {
    let newItem = {
      ...x,
      key: x.id,
    };
    return (newArray = [...newArray, newItem]);
  });
  return newArray;
};

export const customizeDataInverters = (array: plantInfo[]): inverterInfo[] => {
  let newArray: inverterInfo[] = [];
  array.forEach((x) => {
    newArray = [...newArray, ...x.children];
  });
  return newArray;
};

export const performanceList = (
  arrayOne: ResponseData[],
  arrayTwo: ResponseData[]
): ResponseData[] => {
  let newList: ResponseData[] = [];
  arrayOne.forEach((i: ResponseData) => {
    var ts = i.ts;
    var output_value = i.value;
    var estimated: ResponseData | undefined = arrayTwo.find((e) => e.ts === ts);
    var estimated_value = estimated?.value;
    var object = {
      ts: ts,
      value: estimated_value && output_value ? (output_value / estimated_value) * 100 : null,
    };
    newList = [...newList, object];
  });
  return newList;
};

export const formatArray = (array: ResponseData[]): ResponseData[] => {
  let newList: ResponseData[] = [];
  array.map((i) => {
    var ts = i.ts;
    var output_value = i.value ? i.value / 1000 : null;
    var object = {
      ts: ts,
      value: output_value,
    };
    return (newList = [...newList, object]);
  });
  return newList;
};

export const formatArrayAnalytics = (
  array: ResponseData[],
  value: number
): plantAnalyticsInfo | [] => {
  if (array.length === 0) return [];
  let newList: ResponseData[] = [];
  let total: number = 0;
  let min: number = 0;
  for (let i = 0; array.length; i++) {
    let newValue = array[i].value;
    if (newValue !== null) {
      min = newValue;
      break;
    }
  }
  let max: number = 0;
  array.forEach((i) => {
    var ts = i.ts;
    var output_value = i.value ? i.value / (1000 * value) : null;
    if (output_value) {
      total += output_value;
      min = parseFloat(output_value?.toFixed(3)) < min ? parseFloat(output_value?.toFixed(3)) : min;
      max = parseFloat(output_value?.toFixed(3)) > max ? parseFloat(output_value?.toFixed(3)) : max;
    }
    var object = {
      ts: ts,
      value: output_value ? parseFloat(output_value?.toFixed(3)) : null,
    };
    newList = [...newList, object];
  });

  let newObject: titleInfoTwo[] = [
    {
      title: 'Total',
      value: parseFloat(total.toFixed(3)),
    },
    {
      title: 'Highest',
      value: parseFloat(max.toFixed(3)),
    },
    {
      title: 'Average',
      value: parseFloat((total / array.length).toFixed(3)),
    },
    {
      title: 'Lowest',
      value: parseFloat(min.toFixed(3)),
    },
  ];
  let responseData: plantAnalyticsInfo = {
    assetInfo: newObject,
    dataChart: newList,
  };
  return responseData;
};

export const formatToday = (array: ResponseData[]): number => {
  const day = moment(moment().format('YYYY-MM-DD')).valueOf();
  let count: number | null = null;
  array.forEach((item) => {
    if (item.ts === day) {
      count = item.value;
    }
  });
  return count ? count : 0;
};

export const sumArray = (array: ResponseData[], type: boolean): number => {
  let sum = 0;
  array.forEach((item: ResponseData) => {
    if (item.value) {
      sum += item.value;
    }
  });
  return type ? parseInt((sum / 1000).toString()) : sum;
};

export const formatDataChart = (object: any, array_one: string[], array_two: any[]) => {
  if (Object.keys(object).length === 0) return object;
  let newObject = object;
  array_one.forEach((index: string) => {
    let newList: ResponseData[] = [];
    let newItem = array_two.find((x) => x.key === index);
    object[index].forEach((item: ResponseData) => {
      if (item.value !== null) {
        let newObject = {
          ts: item.ts,
          value: parseFloat((item.value * newItem.scale).toFixed(2)),
        };
        newList = [...newList, newObject];
      } else {
        newList = [...newList, item];
      }
    });
    newObject[index] = newList;
  });
  return newObject;
};

export const customDataChartPowerAndIrra = (
  arrayOne: ResponseData[],
  arrayTwo: ResponseData[]
): responseDataChart => {
  let newArray: objectPowerAndIrra[] = [];
  if (arrayOne.length >= arrayTwo.length) {
    arrayOne.forEach((item) => {
      let newObject = arrayTwo.find((i) => i.ts === item.ts);
      if (newObject) {
        newArray = [...newArray, { ts: item.ts, power: item.value, irra: newObject.value }];
      } else {
        newArray = [...newArray, { ts: item.ts, power: item.value, irra: null }];
      }
    });
  } else {
    arrayTwo.forEach((item) => {
      let newObject = arrayOne.find((i) => i.ts === item.ts);
      if (newObject) {
        newArray = [...newArray, { ts: item.ts, power: newObject.value, irra: item.value }];
      } else {
        newArray = [...newArray, { ts: item.ts, power: null, irra: item.value }];
      }
    });
  }
  return { data: newArray, value: arrayTwo.length === 0 ? 1 : 2 };
};
export const customDataTemperatureChart = (
  arrayOne: ResponseData[],
  arrayTwo: ResponseData[],
  arrayThere: ResponseData[]
): responseDataReport => {
  let newArray: objectPowerAndIrra[] = [];
  let listLength = [
    {
      label: 'power',
      count: arrayOne.length,
      array: arrayOne,
    },
    {
      label: 'irra',
      count: arrayTwo.length,
      array: arrayTwo,
    },
    {
      label: 'temp',
      count: arrayThere.length,
      array: arrayThere,
    },
  ].sort((a, b) => b.count - a.count);

  listLength[0].array.forEach((item) => {
    let newObjectOne = listLength[1].array.find((i) => i.ts === item.ts);
    let propertyOne = newObjectOne ? newObjectOne.value : null;
    let newObjectTwo = listLength[2].array.find((i) => i.ts === item.ts);
    let propertyTwo = newObjectTwo ? newObjectTwo.value : null;
    let newObject = {
      ts: item.ts,
      power:
        listLength[0].label === 'power'
          ? item.value
          : listLength[1].label === 'power'
          ? propertyOne
          : propertyTwo,
      temp:
        listLength[0].label === 'temp'
          ? item.value
          : listLength[1].label === 'temp'
          ? propertyOne
          : propertyTwo,
      irra:
        listLength[0].label === 'irra'
          ? item.value
          : listLength[1].label === 'irra'
          ? propertyOne
          : propertyTwo,
    };
    newArray = [...newArray, newObject];
  });
  return {
    data: newArray,
    value: arrayTwo.length === 0 ? 'irra' : arrayThere.length === 0 ? 'temp' : 'ok',
  };
};

export const customAccrualChart = (
  arrayOne: ResponseData[],
  arrayTwo: ResponseData[]
  // value: number
) => {
  let newArrayOne: ResponseData[] = [];
  let newArrayTwo: ResponseData[] = [];
  let nextEnergy: number = arrayOne[0].value ? arrayOne[0].value : 0;
  let nextEstimated: number = arrayTwo[0].value ? arrayTwo[0].value : 0;
  arrayOne.forEach((item, index) => {
    if (index !== 0 && item.value !== null) {
      nextEnergy += item.value;
      if (arrayTwo.length > index) {
        let newValue = arrayTwo[index].value;
        if (newValue !== null) nextEstimated += newValue;
        newArrayTwo = [...newArrayTwo, { ts: item.ts, value: nextEstimated }];
      }
      // if (arrayTwo.length + 1 === index) {
      //   nextEstimated += value;
      //   newArrayTwo = [...newArrayTwo, { ts: item.ts, value: nextEstimated }];
      // }
    }
    newArrayOne = [...newArrayOne, { ts: item.ts, value: nextEnergy }];
  });
  return { estimated: newArrayTwo, energy: newArrayOne };
};

export const customTimeToNumber = (d: number, h: number, m: number) => {
  return d * 24 * 60 * 60 + h * 60 * 60 + m * 60;
};
export const customNumberToTimes = (value: number): objectTimes => {
  let d = 0;
  let h = 0;
  let m = 0;
  if (value >= 86400) {
    d = Math.floor(value / 86400);
    let newHours = value % 86400;
    if (newHours !== 0) {
      h = Math.floor(newHours / 3600);
      let newMinute = newHours % 3600;
      if (newMinute !== 0) {
        m = Math.floor(newMinute / 60);
      }
    }
  } else if (value >= 3600) {
    h = Math.floor(value / 3600);
    let newMinute = value % 3600;
    if (newMinute !== 0) {
      m = Math.floor(newMinute / 60);
    }
  } else if (value >= 60) {
    m = Math.floor(value / 60);
  }
  return {
    day: d,
    hours: h,
    minute: m,
  };
};
